module.exports = __webpack_public_path__ + "img/floor2_12.67b35340.jpg";